import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { LoginWindow } from "../../components/LoginWindow";

const LoginPage = () => {
  const navigate = useNavigate();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const [queryParams] = useSearchParams();
  const churchId = queryParams.get("churchId") ?? "";

  useEffect(() => {
    if (authStatus === "authenticated") {
      navigate(`/churches/${churchId}`);
    }
  }, [navigate, authStatus, churchId]);

  return (
    <div>
      <LoginWindow />
    </div>
  );
};

export default LoginPage;
